import { JSONTransformer } from '@atlaskit/editor-json-transformer';
var jsonTransformer = new JSONTransformer();
export var unknown = function unknown(node) {
  var content = JSON.stringify(jsonTransformer.encodeNode(node));
  return node.isBlock ? "{adf:display=block}\n".concat(content, "\n{adf}") : "{adf:display=inline}".concat(content, "{adf}");
};